import { Icon } from '@chakra-ui/react';

export const Payments = (props) => (
  <Icon viewBox="0 0 18 14" fill="none" {...props}>
    <rect x="1" y="1" width="16" height="12" rx="2" stroke="#267FFD" strokeWidth="2" />
    <rect opacity="0.5" x="6" y="4" width="6" height="6" rx="3" fill="#267FFD" />
  </Icon>
);
